import type { Store } from 'effector'
import type { ISelectedPaymentContent } from '~/features/payment'
import type { GenPlayerPaymentLogicParams, PaymentItem } from './index.h'

import { combine, createEvent, sample } from 'effector'
import { model as routerModel } from '~/core/router'
import { isPaid, model as paymentModel } from '~/features/payment'
import { model as guestModel } from '~/features/subscriber/guest'
import { nay } from '~/shared/helpers'

export const genPlayerPaymentLogic = <T extends PaymentItem>({
  entityStore,
}: GenPlayerPaymentLogicParams<T>) => {
  const proceedPurchaseClick = createEvent<
    ISelectedPaymentContent | undefined | void
  >()

  const $shouldShowPaymentPopup: Store<boolean | null> = combine(
    {
      guest: guestModel.$guest,
      entity: entityStore,
      query: routerModel.$query,
    },
    ({ guest, entity, query }) => {
      // Trailer never needs payment — resolve before entity so kids pinLockPayment is boolean
      if (query.has('trailer')) return false
      if (!entity) return null

      return nay(guest) && isPaid(entity)
    }
  )

  sample({
    // proceed click - opens shopping cart
    clock: proceedPurchaseClick,
    target: paymentModel.proceed,
  })

  return {
    $showPaymentPopup: $shouldShowPaymentPopup, // inside player Payment popup state
    proceedPurchaseClick,
  }
}
